import * as React from 'react';
import './LoginPage.css';
import { API_URL } from '../../../utils';
import SocialButton from './SocialButton/SocialButton';

export const googleAuth = () => {
		window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A//www.googleapis.com/auth/userinfo.profile https%3A//www.googleapis.com/auth/userinfo.email&access_type=offline&include_granted_scopes=true&response_type=code&redirect_uri=${API_URL}/google/auth&client_id=333763370677-6lj4l5at93lir46kk6bb3jpjpeo0mdpt.apps.googleusercontent.com`;
	};

export const vkAuth = () => {
	window.location.href = `https://oauth.vk.com/authorize?client_id=6822046&display=page&redirect_uri=${API_URL}/vk/auth&scope=email&response_type=code&v=5.103`;
}

export const facebookAuth = () => {
	const FACEBOOK_ID = '347078752921506';

	const facebookEndpoint = `https://www.facebook.com/v7.0/dialog/oauth?client_id=${FACEBOOK_ID}&redirect_uri=${API_URL}/facebook/auth&state=readed&scope=email`;

	window.location.href = facebookEndpoint;
};

const LoginPage: React.FunctionComponent = props => {
	return (
		<div className="loginPage">
			<div className="loginPage__wrapper">
				<div className="loginPage__section">
					<div className="login__header">Войти</div>

					<div className="">Войдите с помощью одной из соц. сетей.</div>

					<div className="login__buttons">
						<SocialButton
							type="facebook"
							onClick={facebookAuth}
							text="Войти с помощью Facebook"
						/>

						<SocialButton
							type="google"
							onClick={googleAuth}
							text="Войти с помощью Google"
						/>

						<SocialButton
							type="vk"
							onClick={vkAuth}
							text="Войти с помощью VK"
						/>
					</div>
				</div>

				<div className="loginPage__section loginPage__section_info">
					<ul>
						<li>Ведите свой читательский календарь</li>

						<li>Находите новые книги по своим предпочтениям</li>

						<li>Смотрите статистику по вашей библиотеке</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default LoginPage;